<template>
  <div>
    <div class="modal" tabindex="-1" role="dialog" id="confirm-disabled-modal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Atenção!</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <input class='form-control inline' id="cbx-confirm-missing" v-model="disable_users_missing" type="checkbox">
            Marcar como inativos os usuários que não estiverem na planilha
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-primary" @click="importUsers" data-dismiss="modal">Confirmar</button>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 float-right">
        <button class="btn btn-add" @click="importUsersBtnClicked">Importar Usuários</button>
        <a @click="exportUsers" style="color:#424241; cursor:pointer " class="btn btn-add mr-2"><i class='fa fa-users'></i></a>
        <a :href="$store.getters.url + '/layouts/importUsersTrial'" target="_blank" class="btn btn-add mr-2"><i class='fa fa-download'></i></a>
        <input hidden type="file" id="importUsersInput" @change="showModalConfirmDisabled" />
      </div>
    </div>

    <div class="row mb-4" v-if="error">
      <div class="col-md-12">
        <div class="alert alert-danger" role="alert">{{ error }}</div>
      </div>
    </div>
    <base-crud
      :ref="table"
      :crudName="crudName"
      :newText="newText"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="false"
      :dataForm="dataForm"
      @fieldUpdated="fieldUpdated"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
export default {
  data() {
    return {
      disable_users_missing: false,
      error: "",
      crudName: "Usuário",
      newText: "Cadastrar Usuário",
      table: "usersTable",
      columns: [
        "id",
        "register",
        "name",
        "cpf",
        "photo_http",
        "company_id",
        "branch_id",
        "sector_id",
        "role_id",
        "actions"
      ],
      options: {
        sortIcon: {
            base : 'space_fas fas',
            is: 'fa-sort',
            up: 'fa-sort-amount-up',
            down: 'fa-sort-amount-down'
        },
        filterByColumn: true,
        debounce: 1000,
        sortable: [
          "id",
          "name",
          'cpf',
          "company_id",
          "branch_id",
          "sector_id",
          "role_id",
        ],
        filterable: ["id", "register", "company_id", "branch_id", "sector_id", "role_id"],
        sortable: ["id", 'name', 'cpf', 'email', "company_id", "branch_id", "sector_id", "role_id"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          name: "Nome",
          cpf: 'CPF',
          company_id: "Empresa",
          branch_id: "Unidade",
          sector_id: "Departamento",
          photo_http: 'Foto',
          role_id: "Cargo",
          id: "#",
          actions: "Ações"
        },
        templates: {
          company_id: function(h, row, index) {
            return row.company ? row.company.fantasy_name : "";
          },
          branch_id: function(h, row, index) {
            return row.branch ? row.branch.name : "";
          },
          sector_id: function(h, row, index) {
            return row.sector ? row.sector.name : "";
          },
          role_id: function(h, row, index) {
            return row.role ? row.role.name : "";
          }
        },
        requestFunction: function(data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["company", "branch", "sector", "role"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function(e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        }
      },
      endPoint: "users/",
      dataForm: {
        title: {
          add: "Novo Usuário",
          edit: "Editar Usuário",
          view: "Visualizar Usuário",
          icon: "fa fa-pen"
        },
        button: {
          back: "/users"
        },
        url: {
          model: "users"
        },
        messages: {
          success: {
            add: "Usuário cadastrado com sucesso!",
            edit: "Usuário alterado com sucesso!"
          }
        },
        fields: [
          {
            name: "name",
            model: "name",
            label: "Nome",
            type: "text",
            isRequired: {
              add: true,
              edit: true
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null
          },
          {
            name: "email",
            model: "email",
            label: "E-mail",
            type: "text",
            isRequired: {
              add: true,
              edit: true
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null
          },
          {
            name: "cpf",
            model: "cpf",
            label: "CPF",
            type: "text",
            isRequired: {
              add: true,
              edit: true
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
            mask: "###.###.###-##"
          },
          {
            name: "professional_career_number",
            model: "professional_career_number",
            label: "Número da carteira profissional",
            type: "text",
            isRequired: {
              add: false,
              edit: false
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
          },
          {
            name: "serie",
            model: "serie",
            label: "Série",
            type: "text",
            isRequired: {
              add: false,
              edit: false
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
          },
          {
            name: "register",
            model: "register",
            label: "Matrícula",
            type: "text",
            isRequired: {
              add: false,
              edit: false
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
          },
          {
            name: "birth_date",
            model: "birth_date",
            label: "Data de Nascimento",
            type: "simple_date",
            isRequired: {
              add: true,
              edit: true
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null
          },
          {
            name: "admission_date",
            model: "admission_date",
            label: "Data de admissão",
            type: "simple_date",
            isRequired: {
              add: false,
              edit: false
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null
          },
          {
            name: "company_id",
            model: "company_id",
            label: "Empresa",
            type: "select",
            isRequired: {
              add: false,
              edit: false
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
            list: [],
            isRelated: ["branch_id"],
            list_label: "fantasy_name"
          },
          {
            name: "branch_id",
            model: "branch_id",
            label: "Unidade",
            type: "select",
            isRequired: {
              add: false,
              edit: false
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
            list: [],
            isRelated: ["sector_id"]
          },
          {
            name: "sector_id",
            model: "sector_id",
            label: "Departamento",
            type: "select",
            isRequired: {
              add: false,
              edit: false
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
            list: [],
            isRelated: ["role_id"]
          },
          {
            name: "role_id",
            model: "role_id",
            label: "Cargo",
            type: "select",
            isRequired: {
              add: false,
              edit: false
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
            list: []
          },
          {
            name: "photo",
            model: "photo",
            label: "Foto",
            type: "file",
            isRequired: {
              add: false,
              edit: false
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null
          },
          {
            name: "phone",
            model: "phone",
            label: "Celular",
            type: "text",
            isRequired: {
              add: false,
              edit: false
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
            mask: "(##) # ####-####"
          },
          {
            name: "type_id",
            model: "type_id",
            label: "Tipo do Usuário",
            type: "select",
            isRequired: {
              add: false,
              edit: false
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
            list: []
          },
          {
            name: "role_type_id",
            model: "role_type_id",
            label: "Tipo do Cargo",
            type: "select",
            isRequired: {
              add: false,
              edit: false
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
            list: []
          },
          {
            name: "viewing_group_id",
            model: "viewing_group_id",
            label: "Grupo de Visualização",
            type: "select",
            isRequired: {
              add: false,
              edit: false
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null,
            list: []
          },
          {
            name: "password",
            model: "password",
            label: "Senha",
            type: "password",
            isRequired: {
              add: true,
              edit: false
            },
            placeholder: "",
            class: "",
            length: "12|6|6",
            offset: null
          }
        ]
      }
    };
  },
  methods: {
    exportUsers() {
      $("#page_loader").show();
      const self = this;
      const api = self.$store.state.api + "users/extract"
      self.$http
          .post(api)
          .then(response => {
              window.open(
                  self.$store.getters.url +
                      "users/download/" +
                      response.data,
                  "_blank"
              );
              $("#page_loader").hide();
          })
          .catch(error => {
            $("#page_loader").hide();
            self.$message("Erro", error.response.data, "error");
          });
    },    
    importUsersBtnClicked() {
      document.getElementById('importUsersInput').value = ''
      $("#importUsersInput").click();
    },
    showModalConfirmDisabled(){
      $("#confirm-disabled-modal").modal('show')
    },
    importUsers() {
      $('#page_loader').show()
      const self = this;
      const api = self.$store.state.api + "import/importUsersTrial";
      self.error = "";

      const fd = new FormData();
      const file = document.getElementById("importUsersInput").files[0];
      if (file) {
        fd.append("file", file);
      } else return;

      fd.append("disable_users_missing", self.disable_users_missing ? 1 : 0);

      self.$http
        .post(api, fd)
        .then(response => {
          self.$refs.usersTable.$refs.table.refresh();
          self.$message(
            "Sucesso",
            "Importação realizada com sucesso",
            "success"
          );
          self.disable_users_missing = false
          $('#page_loader').hide()
        })
        .catch(error => {
          document.getElementById("importUsersInput").value = "";
          self.error = error.response.data;
          if (!self.error) {
            self.$message(
              "Erro",
              "Ocorreu um erro. Por favor, verifique se o tipo de arquivo é XLSX e se todos os dados estão preenchidos de forma correta",
              "error"
            );
          } else {
            self.$message(
              "Erro",
              self.error,
              "error"
            );
          }
          $('#page_loader').hide()
        });
    },
    fieldUpdated: function(field) {
      const self = this;
      if (field.model == "company_id") {
        let filters = "&company_id=" + field.value;
        self.getBranches(filters);
      } else if (field.model == "branch_id") {
        let filters = "&branch_id=" + field.value;
        self.getSectors(filters);
      } else if (field.model == "sector_id") {
        let filters = "&sector_id=" + field.value;
        self.getRoles(filters);
      }
    },
    query: function(query) {
      let columns = {
        id: "id",
        company_id: "company[fantasy_name]",
        branch_id: "branch[name]",
        sector_id: "sector[name]",
        role_id: "role[name]",
        register: "register"
      };
      let filters = "orderByDesc=name&";
      $.each(query, function(index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    },
    getCompanies: function(filters) {
      const self = this;
      const api =
        self.$store.state.api +
        "companies?paginated=false" +
        (filters ? filters : "");
      self.$http
        .get(api)
        .then(response => {
          let found = self.dataForm.fields.find(x => x.name == "company_id");
          if (found) {
            found.list = response.data.data;
          }
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getBranches: function(filters) {
      const self = this;
      const api =
        self.$store.state.api +
        "branches?paginated=false" +
        (filters ? filters : "");
      self.$http
        .get(api)
        .then(response => {
          let found = self.dataForm.fields.find(x => x.name == "branch_id");
          if (found) {
            found.list = response.data.data;
          }
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getSectors: function(filters) {
      const self = this;
      const api =
        self.$store.state.api +
        "sectors?paginated=false" +
        (filters ? filters : "");
      self.$http
        .get(api)
        .then(response => {
          let found = self.dataForm.fields.find(x => x.name == "sector_id");
          if (found) {
            found.list = response.data.data;
          }
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getRoles: function(filters) {
      const self = this;
      const api =
        self.$store.state.api +
        "roles?paginated=false" +
        (filters ? filters : "");
      self.$http
        .get(api)
        .then(response => {
          let found = self.dataForm.fields.find(x => x.name == "role_id");
          if (found) {
            found.list = response.data.data;
          }
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getUserTypes: function() {
      const self = this;
      const api = self.$store.state.api + "usertypes?paginated=false";
      self.$http
        .get(api)
        .then(response => {
          let found = self.dataForm.fields.find(x => x.name == "type_id");
          if (found) {
            found.list = response.data.data.filter(x => x.id != 3);
          }
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getRoleTypes: function() {
      const self = this;
      const api = self.$store.state.api + "role-types?paginated=false";
      self.$http
        .get(api)
        .then(response => {
          let found = self.dataForm.fields.find(x => x.name == "role_type_id");
          if (found) {
            found.list = response.data.data
          }
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getViewingGroups: function(filters) {
      const self = this;
      const api =
        self.$store.state.api +
        "signature_viewing_groups?paginated=false" +
        (filters ? filters : "");
      self.$http
        .get(api)
        .then(response => {
          let found = self.dataForm.fields.find(x => x.name == "viewing_group_id");
          if (found) {
            found.list = response.data.data;
          }
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    }
  },
  mounted() {
    const self = this;
    self.getCompanies();
    self.getBranches();
    self.getSectors();
    self.getRoles();
    self.getUserTypes();
    self.getViewingGroups();
    self.getRoleTypes()
  },
  components: {
    BaseCrud
  }
};
</script>

<style>
  #cbx-confirm-missing {
    display: inline;
    width: 31px;
    height: 17px;
  }
</style>


// WEBPACK FOOTER //
// src/components/User/Crud.vue